module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("This eBook edition published in 2011 by"), _c('br'), _vm._v("\nBirlinn Limited"), _c('br'), _vm._v("\nWest Newington House"), _c('br'), _vm._v("\nNewington Road"), _c('br'), _vm._v("\nEdinburgh"), _c('br'), _vm._v("\nEH9 1QS"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.birlinn.co.uk",
      "target": "_blank"
    }
  }, [_c('i', [_vm._v("www.birlinn.co.uk")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("First published in 2002 by Deerpark Press, Selkirk"), _c('br'), _vm._v("\nThis edition first published in 2007 by Birlinn Limited")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("Copyright © Alistair Moffatt 2002, 2007")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("The moral right of Alistair Moffat to be identified as the author of this work has been asserted by him in accordance with the Copyright, Designs and Patents Act 1988")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored or transmitted in any form without the express written permission of the publisher.")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored or transmitted in any form without the express written permission of the publisher.")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("eBook ISBN: 978-0-85790-114-9")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("British Library Cataloguing-in-Publication Data"), _c('br'), _vm._v("\nA catalogue record for this book is available from the British Library")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-864f5876","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 60
// module chunks = 0